import { useEffect, useState } from 'react';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';

const LOCALSTORAGE_KEY = 'windows10WarningDismissed';

const Windows10Warning = () => {
    const { i18next } = useAppContext();
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        // Only show between August 1, 2025 and October 14, 2025 (inclusive)
        const now = new Date();
        const showAfter = new Date('2025-08-01T00:00:00Z');
        const showUntil = new Date('2025-10-14T23:59:59Z');
        if (
            now < showAfter ||
            now > showUntil ||
            localStorage.getItem(LOCALSTORAGE_KEY) === 'true'
        ) {
            return;
        }
        const detectWindows10 = async () => {
            try {
                const uaData = (navigator as any).userAgentData;
                let isWin10 = false;

                if (uaData?.getHighEntropyValues) {
                    const { platform, platformVersion } =
                        await uaData.getHighEntropyValues([
                            'platform',
                            'platformVersion',
                        ]);
                    // Rough approximation — Windows 11 also reports 10.x
                    if (
                        platform === 'Windows' &&
                        platformVersion.startsWith('10')
                    ) {
                        // Extra check to exclude Win11 if possible
                        if (!navigator.userAgent.includes('Windows 11')) {
                            isWin10 = true;
                        }
                    }
                } else {
                    // Fallback to userAgent string
                    const ua = navigator.userAgent;
                    if (
                        /Windows NT 10\.0/.test(ua) &&
                        !ua.includes('Windows 11')
                    ) {
                        isWin10 = true;
                    }
                }

                if (isWin10) {
                    setShowWarning(true);
                }
            } catch (error) {
                console.warn('OS detection failed:', error);
            }
        };

        detectWindows10();
    }, []);

    const handleClose = () => {
        setShowWarning(false);
        localStorage.setItem(LOCALSTORAGE_KEY, 'true');
    };

    if (!showWarning) return null;
    return (
        <NotifierBanner
            message={i18next.t('notifier.outdated.windows.10')}
            buttonText={i18next.t('dismiss')}
            handleClick={handleClose}
            theme="warning"
        />
    );
};

export default Windows10Warning;
